/**
 * Client-side mirror of the password rules enforced by POST /account/change-password
 * (backend/app/routers/account.py).
 *
 * Kept in one place so the Account page and the forced-reset screen cannot drift
 * from each other or from the server. They previously accepted 8 characters while
 * the backend required 12, so a short password passed the form and came back as a
 * 400 that read like a server fault.
 */
export const PASSWORD_MIN_LENGTH = 12;

/** Human-readable form of the rules below, for labels and placeholders. */
export const PASSWORD_REQUIREMENTS_TEXT =
  `At least ${PASSWORD_MIN_LENGTH} characters, including a letter and a number`;

/**
 * Returns an error message for an invalid new password, or null if it passes.
 * Pass `currentPassword` to also reject reusing the existing one.
 */
export function validateNewPassword(password, currentPassword) {
  const pw = password || '';
  if (pw.length < PASSWORD_MIN_LENGTH || !/\p{L}/u.test(pw) || !/\p{N}/u.test(pw)) {
    return `New password must be at least ${PASSWORD_MIN_LENGTH} characters and include a letter and a number.`;
  }
  if (currentPassword && pw === currentPassword) {
    return 'New password must be different from the current one.';
  }
  return null;
}
